export default __webpack_public_path__ + "static/media/ShapeHandsUp.345f60dd.svg";